import { CryptoCurrencyTypes } from "app/utils/const";

export class CryptoHelper {
  // Test environment requires a different URL structure
  // - /{lowercaseCurency}-testnet/tx/{txHash}
  // Rough way of handling it
  static getBlockchainURL(currency: string, txHash): string {
    if (
      currency === CryptoCurrencyTypes.BTC &&
      (window.location.href.includes("alpha") ||
        window.location.href.includes("sandra") ||
        window.location.href.includes("sonia") ||
        window.location.href.includes("selena") ||
        window.location.href.includes("localhost"))
    ) {
      return `https://www.blockchain.com/${currency.toLowerCase()}-testnet/tx/${txHash}`;
    } else if (currency === CryptoCurrencyTypes.USDT_ERC20) {
      return `https://etherscan.io/tx/${txHash}`;
    } else {
      return `https://www.blockchain.com/${currency.toLowerCase()}/tx/${txHash}`;
    }
  }
}
